import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  box-sizing: border-box;
  position: fixed;
  bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 8px;
  width: 100%;
  height: 64px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #7d7878;
`;

const ButtonNext = styled.button`
  border: none;
  background-color: ${(props) => `${props.disabled ? "#E2E2E2" : "#FF8450"}`};
  color: ${(props) => `${props.disabled ? "#B6B3B3" : "white"}`};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  height: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
`;

const ButtonPrev = styled.button`
  border: none;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  height: 100%;
`;

export default function Footer({ disabled, handleNextClick }) {
  const navigate = useNavigate();

  return (
    <Container>
      <ButtonPrev onClick={() => navigate(-1)}>이전</ButtonPrev>
      <ButtonNext disabled={disabled} onClick={handleNextClick}>
        다음
      </ButtonNext>
    </Container>
  );
}
